/* eslint-disable */
import {
  post,
  get,
  put,
  _delete,
} from '@/lin/plugins/axios'

import _axios from '@/lin/plugins/axios'
import {} from './date'
  
class Stat {
  async getInfo() {
    const res = await get('plugin/xy/stat/detail')
    return res
  }
}

export default new Stat()
